// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/**
 * Created by 不动的推动者 on 2018/5/2.
 */
//
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import 'normalize.css'
import Axios from 'axios'
import Elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../node_modules/element-ui/lib/theme-chalk/display.css';
import echarts from 'echarts'
import initFilter from './common/VueFilter';
import VueClipboard from 'vue-clipboard2'
import OssThumbnail from './components/OssThumbnail.vue'

Elementui.MessageBox.setDefaults({
  closeOnClickModal: false
})

Vue.use(Elementui);
Vue.component('oss-thumbnail', OssThumbnail);
Vue.use(VueClipboard)
Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$ossField = function(record, field) {
  if (!record) return '';
  return record[field + '_signed'] || record[field] || '';
};
initFilter();


import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import axios from 'axios';

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.isLoggedIn) {
      // add global header
      //axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`;
        //'Basic ' + window.btoa(unescape(encodeURIComponent(${localStorage.getItem('token')}+':')))
      axios.defaults.headers.common.Authorization = 'Basic ' + window.btoa(unescape(encodeURIComponent(`${localStorage.getItem('token')}`+':')));
      next();
    } else {
        console.log('not login');
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next(); // make sure to always call next()!
  }
});
router.afterEach(() => {
  NProgress.done() // 结束Progress
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js